import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import { usePageSEO } from '../lib/usePageSEO';

/* Calm 404 — used for any path that no longer maps to a real page
   (e.g. /partner and /admin/commissions removed in iter42). */
export default function NotFound() {
  usePageSEO({
    title: 'Page not found — MyLeaf Legacy',
    description: 'The page you were looking for has moved or no longer exists.',
    noindex: true,
  });
  return (
    <div className="min-h-screen bg-background flex flex-col items-center justify-center px-6 py-20">
      <Link to="/" className="inline-flex mb-10" data-testid="notfound-logo-link">
        <Logo size={96} />
      </Link>
      <div className="max-w-md text-center" data-testid="notfound-page">
        <div className="ml-overline">Page not found</div>
        <h1 className="font-serif text-4xl mt-3 text-[hsl(var(--primary))]">
          This corner of MyLeaf is quiet.
        </h1>
        <p className="mt-4 text-sm text-[hsl(var(--primary)/0.78)] font-medium leading-relaxed">
          The page you're looking for has either moved or is no longer here.
          Let's take you back to the memorials.
        </p>
        <Link
          to="/"
          className="ml-btn-primary mt-8 inline-flex"
          data-testid="notfound-home-btn"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
